import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
const CalculatorLayout = ({
  fields,
  content,
  className,
  cssOverride
}) => {
  return /* @__PURE__ */ jsxs(Box, { className, css: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "{spacing.loose}",
    lg: {
      flexDirection: "row"
    },
    ...cssOverride
  }, children: [
    /* @__PURE__ */ jsx(Box, { css: {
      width: "100%",
      lg: {
        position: "sticky",
        top: "0",
        alignSelf: "flex-start",
        order: 2
      }
    }, children: content }),
    /* @__PURE__ */ jsx(Box, { css: {
      width: "100%",
      lg: {
        minWidth: "240px",
        maxWidth: "300px",
        order: 1
      }
    }, children: fields })
  ] });
};
export {
  CalculatorLayout as default
};
